import React from 'react'

import { Wrapper, Icon } from './styles'

const src = '/img/oh-logo.svg'

const Logo = ({ hide = false, width }) => {
    console.count('Logo Component')

    if (hide) return null

    return (
        <Wrapper width={width}>
            <Icon src={src} alt="openhouse-logo" />
        </Wrapper>
    )
}

export default Logo
